import * as React from 'react';
import { ReactNode } from 'react';
import { AppStoreReviewSubmissionItemState } from '@/types';
import { antGrey, releaseStepReviewItemStateStyle, runwayColors } from '@/components/styles/globalStyles';
import { CheckCircleFilled, ClockCircleFilled, CloseCircleFilled, CloseCircleTwoTone } from '@ant-design/icons';
import Text from 'antd/lib/typography/Text';
import Space from 'antd/lib/space';

export interface AppStoreItemsCardHeaderProps {
    state: AppStoreReviewSubmissionItemState;
}
export const AppStoreItemsCardHeader: React.FC<AppStoreItemsCardHeaderProps> = ({ state }) => {
    const { text, icon } = textAndIconForState(state);

    return (
        <div
            style={{
                display: 'flex',
                width: '100%',
                gap: 14,
                height: 40,
                padding: 12,
                backgroundColor: antGrey.grey4,
                borderBottom: `1px solid ${antGrey.grey5}`,
            }}
        >
            <Space align="center" size={14}>
                {icon}
                <Text style={{ ...releaseStepReviewItemStateStyle }}>{text}</Text>
            </Space>
        </div>
    );
};

const textAndIconForState = (state: AppStoreReviewSubmissionItemState): { text: string; icon: ReactNode } => {
    switch (state) {
        case AppStoreReviewSubmissionItemState.Accepted:
        case AppStoreReviewSubmissionItemState.Approved:
            return { text: 'APPROVED', icon: <CheckCircleFilled style={{ color: runwayColors.statusGreen }} /> };
        case AppStoreReviewSubmissionItemState.Rejected:
            return { text: 'REJECTED', icon: <CloseCircleFilled style={{ color: runwayColors.statusRed }} /> };
        case AppStoreReviewSubmissionItemState.ReadyForReview:
            return {
                text: 'READY FOR REVIEW',
                icon: <ClockCircleFilled style={{ color: runwayColors.statusYellow }} />,
            };
        case AppStoreReviewSubmissionItemState.InReview:
            return {
                text: 'IN REVIEW',
                icon: <ClockCircleFilled style={{ color: runwayColors.statusYellow }} />,
            };

        case AppStoreReviewSubmissionItemState.Removed:
            return { text: 'REMOVED', icon: <CloseCircleTwoTone style={{ color: runwayColors.statusRed }} /> };
    }
};
